
// for faq
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a.FAQs').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const faqSelector = '.section.section--page-width.faq';
      const faqSection = document.querySelector(faqSelector);

      if (faqSection) {
        // FAQ exists on current page
        faqSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        // FAQ not found, redirect to home with hash
        // window.location.href = '/' + '#faq-section';
          window.open('/#faq-section', '_blank');
      }
    });
  });

  if (window.location.hash === '#faq-section') {
    const faqSection = document.querySelector('.section.section--page-width.faq');
    if (faqSection) {
      setTimeout(function () {
        faqSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 300);
    }
  }
  // for testimonail page
  // Run only on testimonials page (handles trailing slash too)
  if (!window.location.pathname.startsWith('/pages/testimonials')) return;

  const hash = window.location.hash;
  if (!hash) return;

  const tag = hash.substring(1); // remove #
  const tabsWrapper = document.querySelector('.story-tabs');
  if (!tabsWrapper) return;

  const targetTab = tabsWrapper.querySelector(`.tab[data-tag="${tag}"]`);
  if (!targetTab) return; // invalid tag, do nothing

  // Activate tab
  tabsWrapper.querySelectorAll('.tab').forEach(tab => {
    tab.classList.remove('active');
  });

  targetTab.classList.add('active');

  // Trigger existing tab click logic (filters, ajax, etc.)
  targetTab.dispatchEvent(new Event('click', { bubbles: true }));

  // Smooth scroll to happy-stories section
  const targetSection = document.querySelector('.happy-stories .subheading');
  if (targetSection) {
    setTimeout(() => {
      targetSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 300); // small delay so tab content loads first
  }
});
